export const createChainedFunction = (
  ...funcs: (((...args: any[]) => any) | undefined | null)[]
) => {
  return funcs.reduce<(...args: any[]) => any>(
    (acc, func) => {
      if (func === undefined || func === null) {
        return acc;
      }

      if (typeof func !== 'function') {
        throw new Error(
          'Invalid Argument Type, must only provide functions, undefined, or null.',
        );
      }

      return function chainedFunction(this: unknown, ...args: any[]) {
        acc.apply(this, args);
        func.apply(this, args);
      };
    },
    () => {},
  );
};
